import React from 'react';

export default class Default extends React.Component {
    static propTypes = {
        remark: React.PropTypes.string
    };

    render() {
        const {remark} = this.props;

        if (!remark) {
            return false;
        }

        return (
            <div className="event-stats">
                <div className="event-comments">{remark}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/sports/Default.jsx